import { Fragment, useCallback, type FC, type PropsWithChildren } from 'react';
import { useNavigate } from 'react-router';

import { NestedPageHeader } from '#packages/web/layouts/page/header';
import {
  PageContent,
  type PageContentProps,
} from '#packages/web/layouts/page/page-content';

import { PageErrorBoundary } from './page-error-boundary';

export type NestedPageLayoutProps = {
  /**
   * Title to display at the top of the page.
   */
  title: string;

  /**
   * Props to pass to the PageContent component.
   */
  pageContentProps?: Partial<PageContentProps>;

  /**
   *
   */
  onErrorActionClick?: () => void;
};

export const NestedPageLayout: FC<PropsWithChildren<NestedPageLayoutProps>> = ({
  title,

  pageContentProps,
  onErrorActionClick = useCallback(() => window.location.reload(), []),

  children,
}) => {
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Fragment>
      <NestedPageHeader title={title} onNavigationIconClick={goBack} />
      <PageContent {...pageContentProps}>
        <PageErrorBoundary onActionClick={onErrorActionClick}>
          {children}
        </PageErrorBoundary>
      </PageContent>
    </Fragment>
  );
};
